import classNames from "classnames";
import { Notification } from "interface/notification";
import { FC, useState } from "react";
import './notificationItem.scss';
import { useOnahDispatch } from "store/hooks";
import { markNotificationRead } from "store/slices/notification";

interface Props {
    item: Notification;
};

export const NotificationItem: FC<Props> = ({item}) => {
    const dispatch = useOnahDispatch();
    const [isOpened, setIsOpened] = useState(false);

    const onHandleClick = () => {
        setIsOpened(oldState => !oldState);
        if(item.status === 'UNREAD') {
            dispatch(markNotificationRead(item.id))
        }
    };
    
    return (
        <div className="border-t border-t-gray-inputFieldStroke pt-[22px] pb-[10px] flex items-start" onClick={onHandleClick}>
            <div className="mt-[6px] mr-[9px] flex items-center gap-x-[9px]">
                {item.status === 'UNREAD' && (
                    <div className="h-[12px] w-[12px] rounded-full bg-success"/>
                )}
            </div>
            <div>
                <h6 className={classNames("text-[16px] mb-[4px] 2xl:mb-[6px] font-semibold", item.status === 'UNREAD' ? 'text-black' : 'text-gray-placeholder')}>{item.title}</h6>
                <div className={classNames(
                    "font-medium text-[14px] ",
                    item.status === 'UNREAD' ? 'text-gray-subTextHint' : 
                    'text-gray-placeholder',
                    isOpened ? '' : 'notificationItem__close_message'
                    )}>
                    {item.content}
                </div>

            </div>
        </div>
    )
};

export default NotificationItem;

